import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {EventService, VehicleService} from '../../../../services';
import {compare} from 'fast-json-patch';
import {VehicleDTO, VehicleTyreInfoDTO, VehicleTyresInfoDTO} from "../../../../global/interfaces";
import {} from "../../../../global/services";
import {AdvertEventEnum, TyreDepthEnum, TyrePositionEnum} from "../../../../global/enums";

@Component({
  selector: 'app-vehicle-tyres',
  templateUrl: './vehicle-tyres.component.html',
  styleUrls: ['./vehicle-tyres.component.scss'],
})
export class VehicleTyresComponent implements OnInit {

  @Input() readOnly: boolean;
  @Input() vehicle: VehicleDTO;

  @Output() dataChanged: EventEmitter<any> = new EventEmitter();

  tyreDepths: { label: string, value: number }[] = [];
  form: UntypedFormGroup;
  formState: any;
  showTyreDepths = false;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private vehicleService: VehicleService,
    private eventService: EventService) {
  }

  async ngOnInit() {

    this.showTyreDepths = this.vehicle?.tyres?.length > 0;

    console.log("TYRE DEPTHS ", this.vehicle);

    // create lookup data for allowable tyre depths
    this.tyreDepths = [];

    for (let i = 0; i <= 8; i = i + 0.5) {
      this.tyreDepths.unshift({label: i + "mm", value: i});
    }

    this.tyreDepths.push({label: "N/A", value: null});

    this.form = this.formBuilder.group({
      tyreDepth_NSF: new UntypedFormControl(this.tyreDepth(this.vehicle.tyres, TyrePositionEnum.NSF)),
      tyreDepth_NSR: new UntypedFormControl(this.tyreDepth(this.vehicle.tyres, TyrePositionEnum.NSR)),
      tyreDepth_OSR: new UntypedFormControl(this.tyreDepth(this.vehicle.tyres, TyrePositionEnum.OSR)),
      tyreDepth_OSF: new UntypedFormControl(this.tyreDepth(this.vehicle.tyres, TyrePositionEnum.OSF)),
      tyreDepth_Spare: new UntypedFormControl(this.tyreDepth(this.vehicle.tyres, TyrePositionEnum.SPARE))
    });

    this.formState = this.form.value;

    this.form.valueChanges.subscribe(x => {
      const nsf = this.form.value.tyreDepth_NSF;
      const nsr = this.form.value.tyreDepth_NSR;
      const osr = this.form.value.tyreDepth_OSR;
      const osf = this.form.value.tyreDepth_OSF;
      const spare = this.form.value.tyreDepth_Spare;

      // raise an event with component name and current vehicle patch values as the args
      const patch = compare(this.formState, this.form.value);
      this.formState = this.form.value;

      this.vehicleService.setTyreDepths(this.vehicle.id, patch);
    });
  }

  private tyreDepth(tyresInfo: VehicleTyreInfoDTO[], position: TyrePositionEnum) {

    return tyresInfo?.find(x => x.position === position)?.depth;
  }
}
